import React from 'react';
import { connect } from 'react-redux';
import Icon from 'jsx/components/core/icons/Icon';

import { Row, Col } from 'reactstrap';

import { Route, Switch, Link } from 'react-router-dom';
import { routes } from '../constants/routes';
import AppMenuItem from '../components/core/menu/components/AppMenuItem';

import clt_logo from '../../images/carbonizer/logo_horizontal_negative.png';
import ets_logo from '../../images/elementree/logo_horizontal.png';
import wipstar_logo from '../../images/wipstar/logo_horizontal.png';
import farmeye_logo from '../../images/farmeye/logo_horizontal.png';

class HomeHorizontal extends React.Component {
  constructor() {
    super();

    this.state = {
      narrowSidebar: false,
    };

    this.toggleSidebar = this.toggleSidebar.bind(this);
  }

  toggleSidebar() {
    this.setState({ narrowSidebar: !this.state.narrowSidebar });
  }

  render() {
    const { match, location } = this.props;
    const { narrowSidebar } = this.state;
    const { currentApp } = this.props.realm;
    const { isMasquerade } = this.props.auth;
    const { loggedInAs } = this.props;

    let logo = null;
    switch (currentApp.id) {
      case 'farmportrait':
        logo = farmeye_logo;
        break;
      case 'wipstar':
        logo = wipstar_logo;
        break;
      case 'elementree':
        logo = ets_logo;
        break;
      case 'carbonizer':
      default:
        logo = clt_logo;
        break;
    }

    let manageItems = <small className="p-2 text-secondary text-center">No Manage Items</small>;
    if (currentApp.manage.length > 0) {
      manageItems = currentApp.manage.map((manageItem, index) => (
        <AppMenuItem
          key={`app-menu-item-${index}`}
          url={manageItem.url}
          caption={manageItem.caption}
          iconName={manageItem.iconName}
          location={location}
          disabled
          iconsOnly={narrowSidebar}
        />
      ));
    }

    let menuItems = <small className="p-2 text-secondary text-center">No Realm Items</small>;
    if (currentApp.manage.length > 0) {
      const canViewSamplingPlans = currentApp.features.includes('samplingPlansView');
      menuItems = currentApp.menus
        .filter((menu) => {
          if (menu.caption.includes('Sampling Plans')) {
            return canViewSamplingPlans;
          }
          return true;
        })
        .map((menu, index) => (
          <AppMenuItem
            key={`app-menu-item-${index}`}
            url={menu.url}
            caption={menu.caption}
            iconName={menu.iconName}
            location={location}
            disabled
            iconsOnly={narrowSidebar}
          />
        ));
    }

    let className = 'listview p-0';
    if (narrowSidebar) {
      className += ' listview-narrow';
    }
    const routesToRender = routes.flatMap(({ tabs = [], exact, component, ...route }, index) => {
      const ComponentToRender = component;
      const tabSubroutes = tabs.map((currentTab) => ({
        exact,
        // key: `tab-${index}-${currentTab}`,
        path: `${match.path}${route.path}/${currentTab}`,
        render: (routeProps) => <ComponentToRender {...routeProps} tabRoutes={tabs} />,
      }));

      return [
        ...tabSubroutes,
        {
          exact,
          // key: `tab-${index}`,
          path: `${match.path}${route.path}`,
          render: (routeProps) => <ComponentToRender {...routeProps} tabRoutes={tabs} />,
        },
      ];
    });

    return (
      <>
        {isMasquerade && currentApp.id === 'wipstar' && (
          <div className="masquerade-tooltip">Masquerade</div>
        )}
        <Row className="m-0 p-0 d-flex flex-row flex-grow-1">
          <Col className={className} onClick={this.toggleSidebar}>
            <div className="header text-center border-bottom p-2">
              {!narrowSidebar && (
                <Link to="/home">
                  {logo && (
                    <img
                      src={logo}
                      alt={currentApp.title}
                      // style={{ maxWidth: '200px' }}
                      className="p-1"
                    />
                  )}
                  {!logo && (
                    <div className="d-flex justify-content-center p-1 app-menu-header">
                      <Icon className="mt-2" name={currentApp.icon} />
                      <span className="text-white ml-3">{currentApp.title}</span>
                    </div>
                  )}
                </Link>
              )}
              {narrowSidebar && (
                <div style={{ height: 32 }}>
                  <Icon size="1x" name={currentApp.icon} />
                </div>
              )}
            </div>

            <div>
              {!narrowSidebar && (
                <div className="section-header mt-3">
                  <span className="section-title">MODULES</span>
                </div>
              )}
              <ul className="list-group">{menuItems}</ul>
            </div>
            <div className="section-header">
              {!narrowSidebar && <span className="section-title">Manage</span>}
            </div>

            <ul className="list-group">{manageItems}</ul>

            {!narrowSidebar && (
              <div className="text-center p-2">
                <small className="text-corporate">{loggedInAs}</small>
              </div>
            )}
          </Col>
          <Col className="m-0 p-0 overflow-auto">
            <Switch>
              {routesToRender.map((props, index) => (
                <Route key={`route-${index}`} {...props} />
              ))}
            </Switch>
          </Col>
        </Row>
      </>
    );
  }
}

const mapStoreToProps = (store) => ({
  loading: store.ajaxRequests.calls > 0,
  realm: store.realm,
  manage: store.manage,
  profile: store.profile,
  auth: store.auth,
});

export default connect(mapStoreToProps)(HomeHorizontal);
